module.exports = __webpack_public_path__ + "media/images/rank/silver-sm-b4b0fe5c90b04b6db2c8d0ea704d67b7.svg";